import { parseIntegrationData } from './deviceIntegration';

export const lgData = (device) => parseIntegrationData(device?.integration_data || device?.integrationData);
export const isLgTv = (device) => device?.type === 'lgtv' || lgData(device).remoteTarget?.protocol === 'lg_webos_remote';
export const lgPlayerId = (device) => Number(lgData(device).remoteTarget?.playerLink?.deviceId) || null;
export const isLgPlayer = (device) => !/Android/i.test(device?.user_agent || '') && device?.status !== 'placeholder'
  && (lgData(device).playerNode?.platform === 'webos' || /web[o0]s|netcast|SuitestreamPlayer\/webos/i.test(device?.user_agent || ''));
export function visiblePhysicalDevices(devices = []) {
  const ids = new Set(devices.map((device) => Number(device.id)));
  const linked = new Set(devices.filter(isLgTv).map(lgPlayerId).filter((id) => ids.has(id)));
  return devices.filter((device) => !linked.has(Number(device.id)));
}
export function lgDeviceLabel(device) {
  return `${device.name || `Device ${device.id}`}${isLgTv(device) ? lgPlayerId(device) ? ' · IP Control + Player' : ' · IP Control' : isLgPlayer(device) ? ' · Player' : ''}`;
}
export function playbackDevice(device, devices = []) {
  if (!isLgTv(device) || !lgPlayerId(device)) return device;
  const player = devices.find((entry) => Number(entry.id) === lgPlayerId(device));
  return player ? { ...player, name: device.name, tvControlDevice: device } : device;
}
